import { render, staticRenderFns } from "./CustomizedGoodsTable.vue?vue&type=template&id=189a7aee&scoped=true&"
import script from "./CustomizedGoodsTable.vue?vue&type=script&lang=js&"
export * from "./CustomizedGoodsTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomizedGoodsTable.vue?vue&type=style&index=0&id=189a7aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189a7aee",
  null
  
)

export default component.exports